var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 8.458 0 4.686 2.343 2.343S8.458 0 16 0h8c7.543 0 11.314 0 13.657 2.343S40 8.458 40 16v8c0 7.543 0 11.314-2.343 13.657S31.543 40 24 40h-8c-7.542 0-11.314 0-13.657-2.343S0 31.543 0 24v-8z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.072 20.345c0-.97-.094-1.97-.25-2.909H20.278v5.537h7.757a6.526 6.526 0 0 1-2.878 4.347l4.63 3.598c2.721-2.534 4.285-6.225 4.285-10.573z",
    fill: "#4280EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.278 34.358c3.878 0 7.131-1.283 9.509-3.472l-4.63-3.566c-1.282.876-2.94 1.376-4.88 1.376-3.753 0-6.912-2.534-8.07-5.912l-4.754 3.66a14.343 14.343 0 0 0 12.825 7.914z",
    fill: "#34A353"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.207 22.753a8.723 8.723 0 0 1 0-5.505l-4.754-3.69a14.377 14.377 0 0 0 0 12.886l4.754-3.69z",
    fill: "#F6B704"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.278 11.336a7.834 7.834 0 0 1 5.505 2.158l4.097-4.129c-2.596-2.44-6.037-3.753-9.602-3.722a14.343 14.343 0 0 0-12.825 7.914l4.754 3.69c1.158-3.409 4.317-5.911 8.07-5.911z",
    fill: "#E54335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.11c091035452932f8c476a6c4d28745b.svg";
export { ForwardRef as ReactComponent };